import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { DiscussionIcon, EditIcon, Header2, PinIcon, Tooltip, IconButton } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getProjectNameWithIdSelector } from "~/store/selectors/selector.projects";
import { DiscussionOptions } from "./DiscussionOptions/DiscussionOptions";
import { Metadata } from "./Metadata";
import { Navigation } from "./Navigation";
import NewCommentsNotification from "../comments/NewCommentsNotification";
import HiddenFromClients from "../tasks/Signifiers/HiddenFromClients";

export const Header = ({
  id,
  name,
  hiddenFromClients,
  pinned,
  createdOn,
  createdById,
  createdByName,
  createdByEmail,
  projectId,
  className,
  onEdit,
  showNavigation,
}) => {
  const projectName = useSelector((state) => getProjectNameWithIdSelector(state, projectId));
  const { t } = useTranslation();

  return (
    <div className={classNames("tw-relative", className)}>
      <div className="tw-flex tw-justify-between tw-mb-2">
        <div>
          <DiscussionIcon
            className="tw-mr-3 tw-align-middle"
            fill="var(--color-theme-800)"
          />
          <Header2
            weight="bold"
            className="tw-mr-1 tw-align-middle"
            as="span"
          >
            {name}
          </Header2>
          {pinned ? (
            <div className="tw-inline-flex tw-items-center modal-header-icon tw-align-middle">
              <PinIcon />
            </div>
          ) : null}
          <HiddenFromClients
            hiddenFromClients={hiddenFromClients}
            className="modal-header-icon tw-inline-flex tw-align-middle"
          />
        </div>
        <div className="tw-flex tw-h-fit tw-ml-2 tw--mt-1">
          {showNavigation ? (
            <Navigation
              discussionId={id}
              projectId={projectId}
            />
          ) : null}
          {onEdit ? (
            <Tooltip title={t("Edit")}>
              <IconButton
                aria-label="Edit"
                className="tw-mr-1"
                variant="text gray"
                onClick={onEdit}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          ) : null}
          <DiscussionOptions
            id={id}
            projectId={projectId}
            createdById={createdById}
          />
        </div>
      </div>
      <Metadata
        createdOn={createdOn}
        createdById={createdById}
        projectName={projectName}
        projectId={projectId}
        createdByName={createdByName}
        createdByEmail={createdByEmail}
      />
      <NewCommentsNotification
        parentType="Discussion"
        parentId={id}
      />
    </div>
  );
};

Header.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  hiddenFromClients: PropTypes.bool,
  pinned: PropTypes.bool,
  createdById: PropTypes.number,
  createdByName: PropTypes.string,
  createdByEmail: PropTypes.string,
  createdOn: PropTypes.number,
  projectId: PropTypes.number,
  className: PropTypes.string,
  onEdit: PropTypes.func,
  showNavigation: PropTypes.bool,
};

Header.defaultProps = {
  hiddenFromClients: false,
  pinned: false,
  showNavigation: false,
  createdById: 0,
  createdOn: 0,
  projectId: 0,
};
